import { EmailVerificationForm } from './EmailVerificationForm'

interface EmailVerificationStepProps {
  email: string
  customerInfoId: string
  onComplete: () => void
}

export function EmailVerificationStep({ email, customerInfoId, onComplete }: EmailVerificationStepProps) {
  return (
    <EmailVerificationForm
      email={email}
      customerInfoId={customerInfoId}
      onSuccess={onComplete}
      onResendCode={() => {
        // Additional logic for resend could go here if needed
      }}
    />
  )
}

